<template>
  <button
    class="copy copy-click"
    @click="
      () => {
        copy(source)
        toggleClick()
      }
    "
  >
    <p class="copy__title">{{ count ? 'کد هدیه' : 'لینک دعوت' }}</p>
    <div class="copy__row" :class="!count ? 'copy__extra-width' : 'copy__gap'">
      <div :class="!count && 'copy__link'">
        <p>{{ count ? count : link }}</p>
      </div>
      <img :src="Copy" alt="Icon" />
    </div>
    <div v-if="toggleCopy" class="copy__success-copy">
      <p>کپی شد!</p>
    </div>
  </button>
</template>

<script setup>
import { useClipboard } from '@vueuse/core'

import Copy from '~/assets/images/copy.png'

const props = defineProps({
  count: { type: String, default: '' },
})

const user = useUserStore()

const link = user.shareLink

const source = ref(props.count ? props.count : link)

const toggleCopy = ref(false)

const toggleClick = () => {
  toggleCopy.value = true

  setTimeout(() => {
    toggleCopy.value = false
  }, 1000)
}

const { text, copy, copied } = useClipboard({ source })
</script>

<style lang="scss" scoped>
.copy {
  height: 66px;
  background: linear-gradient(180deg, #794a98 50.48%, #653684 53.37%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 20px;
  width: 50%;
  font-size: 24px;
  color: #fff;
  font-weight: 700;
  border: 4px solid rgba(0, 0, 0, 0.1);
  color: #fff;
  padding: 0 10px;
  position: relative;

  @media screen and (max-width: 768px) {
    height: 43px;
    border-radius: 13px;
  }

  &__title {
    font-weight: 900;
    font-size: 16px;
    // font-family: Croissant;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #471866;
    border-radius: 10px;
    height: 44px;
    padding: 0 16px;
    @media screen and (max-width: 768px) {
      height: 31px;
    }
    p {
      font-size: 11px;
    }
    img {
      width: 16px;
    }
  }

  &__extra-width {
    width: 50%;
    @media screen and (max-width: 768px) {
      width: 40%;
    }
  }

  &__gap {
    gap: 7px;
  }

  &__link {
    width: 60%;
    border-radius: 8px;
    direction: ltr;
    p {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 10px;
      font-size: 16px;
    }
  }

  &__success-copy {
    width: 100px;
    height: 40px;
    background-color: #11c388;
    color: #fff;
    display: grid;
    place-items: center;
    position: absolute;
    top: -20px;
    left: 0;
    border-radius: 12px;
    font-size: 15px;
  }
}
</style>
